import React from 'react';

import { CircularProgress, Typography } from '@mui/material';
import { AlineDialog } from 'src/components/generic';
import { doNothing } from 'src/helpers';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  dialogContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    justifyContent: 'center',
    padding: theme.spacing(8),
  },
}));

export function CreatingDocumentsDialog({ open }: { open: boolean }) {
  const { classes } = useStyles();

  return (
    <AlineDialog disableAltClose open={open} onClose={doNothing}>
      <div className={classes.dialogContent}>
        <CircularProgress size={48} />
        <Typography variant="subtitle1">Creating documents</Typography>
        <Typography>This may take a some time...</Typography>
      </div>
    </AlineDialog>
  );
}
